
import Hashtag1 from "../../../assets/duotone/Hashtag1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Hashtag1Icon({ className, dataTestid = "Hashtag1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hashtag1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
